/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getBomConfig = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.GET}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setBomConfig = async (id, data, params) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.BOM_CONFIG.POST}/${id}`,
      {
        ...data,
      },
      params,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductDevOrder = async (id, query) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.BOM_DEV_ORDER}/${id}`, {
      params: { ...query },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductSuggestions = async (query) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.BOM_PRODUCT_SUGGESTION}`, {
      params: { ...query },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGroupSuggestions = async (query) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.BOM_GROUP_SUGGESTION.GET}`, {
      params: { ...query },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomConfigCards = async (BOMType, devOrder, query) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.GET}/${BOMType}/${devOrder}`, {
      params: { ...query },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setBomConfigCard = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.IMPORT}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGroupLibrarySuggestions = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_CONFIG.BOM_GROUP_SUGGESTION.GROUP_LIB_LIST}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTrafficLights = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.GET_TRAFFIC_LIGHTS.GET}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductDetails = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.FETCH_PRODUCT_LIST.GET}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveBomList = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.FETCH_PRODUCT_LIST.POST}/${id}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const removeConfigCards = async (BOMType, devOrder, body) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.DELETE}/${BOMType}/${devOrder}`, {
      data: body,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSequence = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_CONFIG.SAVE_SEQUENCE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createConfigCard = async (BOMType, devOrder, body) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.CREATE}/${BOMType}/${devOrder}`, {
      ...body,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateBomConfigCards = async (BOMType, devOrder, bomLibId, query) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.UPDATE}/${BOMType}/${devOrder}/${bomLibId}`, {
      ...query,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addToLibrary = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.ADDTOLIBRARY}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addBomApproval = async (bomTypeId, devOrderId, body) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.QUALITY_APPROVED}/${bomTypeId}/${devOrderId}`, { ...body });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomSupplier = async (id) => {
  try {
    return apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.BOM_SUPPLIER}`, {
      params: { devOrderId: id },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addColorApproval = async (bomTypeId, devOrderId, body) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.COLOUR_APPROVED}/${bomTypeId}/${devOrderId}`, { ...body });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const removeBomApproval = async (bomTypeId, devOrderId, body) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.REMOVE_QUALITY_APPROVED}/${bomTypeId}/${devOrderId}`, { ...body });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const removeColorApproval = async (bomTypeId, devOrderId, body) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.REMOVE_COLOUR_APPROVED}/${bomTypeId}/${devOrderId}`, { data: body });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const accessModules = async (body) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.GET_ACCESS_MODULES.POST}`, {
      ...body,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addBomTagServices = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_CONFIG.ADD_BOM_TAG}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomTagsList = async () => {
  try {
    return apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.GET_BOM_TAG}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomTagsListById = async (bomId) => {
  try {
    return apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.GET_BOM_BYID}/${bomId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveMultipleBoms = async (bomTypeId, devOrderId, body) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.SAVE_MULITPLE_BOMS}/${bomTypeId}/${devOrderId}`, { ...body });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchLibraryBomsbySearch = async (data) => {
  try {
    return apiClient.get(`${apiEndpoint}${API.BOM_CONFIG.FETCH_FILTERED_BOMS_LIST}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
